import { computed, ref } from 'vue';
import { TransitionPresets, useTransition } from '@vueuse/core';
import { useRouteHash } from '@libs/use';

import {
  ORDER_FILTERS,
  LEGACY_ORDER_STATUSES_GROUPS,
  STATUS,
  ORDERS_LABEL,
  NEW_OMS_ORDER_STATUSES_GROUPS,
} from '../constants';
import { isNewOms } from './useGetOmsStatusQuery';

export default function useFilterOrders(defaultOrders, orderFilter) {
  const routeHash = useRouteHash();

  const filter = ref(
    routeHash.value || orderFilter || ORDER_FILTERS.open.value
  );

  const orders = computed(() => {
    if (filter.value === ORDER_FILTERS.all.value) {
      return defaultOrders.value;
    }

    return defaultOrders.value.filter((order) => {
      if (isNewOms.value) {
        return NEW_OMS_ORDER_STATUSES_GROUPS[filter.value]?.includes(
          order.orderStateId
        );
      }

      return LEGACY_ORDER_STATUSES_GROUPS[filter.value]?.includes(
        order.orderStateId
      );
    });
  });

  const filteredOrdersPercentage = computed(() => {
    return (orders.value.length / defaultOrders.value.length) * 100 || 0;
  });

  const percentage = useTransition(filteredOrdersPercentage, {
    duration: 300,
    transition: TransitionPresets.easeInOutCubic,
  });

  const filterLongLabel = computed(() => {
    if (filter.value === ORDER_FILTERS.all.value) {
      return ORDERS_LABEL;
    } else {
      return `${ORDERS_LABEL} ${STATUS[filter.value]}`;
    }
  });

  return {
    percentage,
    orders,
    filter,
    filterLongLabel,
  };
}
